export const translation = {
  DetainedGpsDeviceValidator: 'Kontener bez ruchu',
  GpsDeviceIssueValidator: 'Incydent kontenera',
  NoResponseGpsDeviceValidator: 'Brak odpowiedzi kontenera',
  NoInvoiceValidator: 'Brak faktury w Optima',
  OptimaSyncValidator: 'Niepoprawna synchronizacja z Opitma',
  WrongAddressPosibilityValidator: 'Możliwy zły adres'
}